import React from 'react'
import { Text, View } from 'react-native'
import styles from './styles'

const NoItems: React.FC = () => {
    return (
        <View style={styles.container}>
            <Text style={styles.text}>Sem itens para exibir</Text>
        </View>
    )
}

export default NoItems
